import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchPermissions } from '../service';
import type { PermissionItem } from '../types';
import { PERMISSIONS_QUERY_KEY } from './usePermissions';

export const usePermissionItems = (): UseQueryResult<PermissionItem[]> => {
	return useQuery({
		queryKey: PERMISSIONS_QUERY_KEY,
		queryFn: fetchPermissions,
		select: (data) => data,
		staleTime: Infinity,
		gcTime: Infinity,
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
	});
};
